import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  SelectTemplateRequest,
  TemplateResponse,
} from "../college-admin-dashbaord/college-template/template.model";

interface resetPasswordPayload {
  password: string;
  confirmedPassword: string;
}

@Injectable({
  providedIn: "root",
})
export class LoginService {
  private readonly templatesApiPath = "/templates";

  constructor(private http: HttpClient) { }

  register(userData: any) {
    return this.http.post(`/auth/register`, userData);
  }

  verifyAccount(data: any) {
    return this.http.post(`/auth/verify`, data);
  }

  forgotPassword(data: any) {
    return this.http.post(`/auth/forgot-password`, data);
  }
  unLockScreen(payload: any) {
    return this.http.post('/authentication/passwordauth', payload)
  }

  resetPassword(data: any) {
    return this.http.post(`/auth/reset`, data);
  }
  resetUserPassword(payload: resetPasswordPayload) {
    return this.http.post("/auth/password/reset", payload);
  }
  checkIfEmailExist(email: string): Observable<any> {
    return this.http.get(`/auth/validateemail/${email}`).pipe();
  }

  checkIfUsernameExist(username: string): Observable<any> {
    return this.http.get(`/auth/validateusername/${username}`).pipe();
  }

  // Get all templates
  fetchAllTemplates(
    type: string = "",
    page: number = 0,
    size: number = 10,
  ): Observable<TemplateResponse> {
    let params = new HttpParams()
      .set("page", page.toString())
      .set("size", size.toString());

    if (type) {
      params = params.set("type", type);
    }

    return this.http.get<TemplateResponse>(`${this.templatesApiPath}/fetchAll`, { params });
  }

  // Select a template
  selectTemplate(request: SelectTemplateRequest): Observable<any> {
    const formData = new FormData();
    formData.append("templateId", request.templateId);
    formData.append("entityType", request.entityType);
    formData.append("tenantId", request.tenantId.toString());

    return this.http.post(`${this.templatesApiPath}/select`, formData);
  }

  getTemplateThumbnail(templateId: string): Observable<Blob> {
    return this.http.get(`${this.templatesApiPath}/${templateId}/thumbnail`, {
      responseType: "blob",
    });
  }

  getTemplatePreview(templateId: string): Observable<Blob> {
    return this.http.get(`${this.templatesApiPath}/${templateId}/preview`, {
      responseType: "blob",
    });
  }

  downloadTemplate(templateId: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.templatesApiPath}/${templateId}/download`, {
      observe: "response",
      responseType: "blob",
    });
  }
}
